// extracted by mini-css-extract-plugin
export var typingIndicator = "_pw-0";